'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.696 17.21c.19 0 .343.154.343.344v1.7h1.25v.686H4.663v-.685h1.25v-1.701c0-.19.154-.343.344-.343Zm-.343.686H6.598v1.359h3.755v-1.359Zm5.025-8.517c.19 0 .343.154.343.343v.518h1.494v-.518c0-.19.153-.343.343-.343h1.491c.19 0 .343.154.343.343v.518h.088c.663 0 1.203.54 1.203 1.204v1.914h-.685v-.719h-7.06v4.829c0 .285.232.518.518.518h.41v.685h-.41c-.664 0-1.204-.54-1.204-1.203v-6.024c0-.664.54-1.204 1.204-1.204h.087v-.518c0-.19.153-.343.343-.343Zm2.613 5.957v1.484l1.135 1.135-.324.323-1.202-1.202a.229.229 0 0 1-.067-.162v-1.578h.458Zm1.087-9.063c.189 0 .342.153.342.343v1.837c0 .19-.153.343-.342.343H10.22l.01 7.728-.685.001-.002-1.775h-1.94l1.39 1.631-.349.297-1.24-1.456.002 1.302-.685.001-.01-7.729H3.343A.343.343 0 0 1 3 8.453V6.616c0-.19.154-.343.343-.343Zm-9.539 5.893-1.917 2.127h1.92l-.003-2.127Zm-.21-.45H7.4l.003 2.138 1.926-2.138Zm5.706-1.651h-.807v.518c0 .19-.153.343-.342.343h-.43a.519.519 0 0 0-.518.518v.51h7.06v-.51a.519.519 0 0 0-.518-.518h-.43a.343.343 0 0 1-.343-.343v-.518H17.9v.518c0 .19-.153.343-.342.343h-2.18a.343.343 0 0 1-.343-.343v-.518Zm-7.638-.95.003 2.144h1.93L7.396 9.115Zm2.138-.319h-1.81l1.813 2.011-.003-2.01Zm8.11-1.52-1.093.835h2.183v-.004l-1.09-.832Zm-13.96.262v.573h.75l-.75-.573Zm11.097-.263-1.092.836h2.185l-1.093-.836Zm-2.86 0-1.092.836h2.184l-1.092-.836Zm-2.86 0-1.093.836h2.185L9.06 7.275Zm-2.86 0-1.092.836h2.183l-1.091-.836Zm-.338-.317H3.686v.004l1.087.832 1.09-.836Zm11.443 0h-2.186l1.092.836 1.094-.836Zm-2.863 0H12.26l1.093.836 1.091-.836Zm-2.86 0H9.4l1.093.836 1.092-.836Zm-2.86 0H6.538l1.092.836 1.092-.836Zm10.01 0h-.75l.75.574v-.574ZM8.023 3.07a.343.343 0 0 1 .312-.053l7.188 2.321-.21.653-7.018-2.267-2.91 2.214-.416-.546Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17.762 20.15a3.24 3.24 0 0 1-3.236-3.236 3.239 3.239 0 0 1 3.644-3.21l-.087.68a2.553 2.553 0 0 0-2.871 2.53 2.553 2.553 0 0 0 2.55 2.55 2.539 2.539 0 0 0 2.517-2.136l.676.11a3.222 3.222 0 0 1-3.193 2.712",
    fill: "#87868F"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m21.846 16.914-1.181 1.182-1.182-1.182h.839a2.553 2.553 0 0 0-2.55-2.55v-.686a3.24 3.24 0 0 1 3.236 3.236h.838Z",
    fill: "currentColor"
  })));
});
var FwSet0Constructionyear4 = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Constructionyear4 = FwSet0Constructionyear4;